import { Component, Input, OnInit } from '@angular/core';
import { EventViewModel } from '../../../models-views/event.view.model';
import { ActivatedRoute } from '@angular/router';
import { PaymentResponseModel } from '../../../models/event.model';
import { BehaviorSubject, debounceTime, Subject } from 'rxjs';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { CetPaymentModalComponent } from './cet-payment-modal/cet-payment-modal.component';
import { CetPaymentsDetailsComponent } from '../../cet-payments-details/cet-payments-details.component';
import { environment } from '../../../../environments/environment';
import { CetVendorDetailsComponent } from '../cet-vendor-details/cet-vendor-details.component';

@Component({
  selector: 'app-cet-payments',
  standalone:false,
  templateUrl: './cet-payments.component.html',
  styleUrl: './cet-payments.component.scss'
})
export class CetPaymentsComponent implements OnInit {

  @Input() eventId: null | string = null;
  loading = false
  paymentList = [];
  paymentResponseModel = new BehaviorSubject<PaymentResponseModel>(new PaymentResponseModel())
  cetPaymentModalRef:any
  rfqRef?: NzModalRef;
  searchChange$ = new Subject();
  searchText: string ;
  constructor( private modalService: NzModalService, private vm: EventViewModel,  private route: ActivatedRoute
  ) {
    this.vm.cetPaymentsComponent = this
      this.searchChange$.pipe(debounceTime(500)).subscribe(name => {
                  this.getData()
            });
  }

  ngOnInit(): void {
    this.vm.subscribeToPayment(this.paymentResponseModel)
  }

  getData(){
    this.loading = true
    this.vm.getPayments(1, 100, this.eventId, this.searchText)
  }
  onSearch() {
    this.searchChange$.next(this.searchText);
  }

  paymentRecieved(){
    this.paymentList = this.paymentResponseModel.value.results
    this.loading = false
  }

  onAdd(){
     this.cetPaymentModalRef =  this.modalService.create({
        nzTitle: 'Add Payment',
        nzContent: CetPaymentModalComponent,
        nzFooter:null,
        nzWidth: '800px',
        nzClosable: true,
        // nzOnOk: () => new Promise(resolve => setTimeout(resolve, 1000))
      });

      this.cetPaymentModalRef.afterClose.subscribe(result => {
        if (result === true) {
          this.getData();
        }
        });
    }

 getFileName(file_url:string): string {
    return file_url.split('/').pop()?.split('?')[0] || '';
  }

  getFileDownloadLink(file_url:string): string {
      return `${environment.api_url}${file_url}`
  } 


  onDetailsOpen(id:number){
       this.cetPaymentModalRef = this.modalService.create({
          nzTitle: 'Payment Details',
          nzContent: CetPaymentsDetailsComponent,
          nzFooter:null,
          nzData: {
          id: id  , name:'' // 👈 This is how you pass data
         },
          nzWidth: '800px',
          nzStyle:{top:'50px'},
          nzClosable: true,
          // nzOnOk: () => new Promise(resolve => setTimeout(resolve, 1000))
        });
    
        this.cetPaymentModalRef.afterClose.subscribe(result => {
          if (result === true) {
            this.getData();
          }
    });
}

  
  deletePayment(id:number){
    console.log(id)
    this.loading = true
    this.vm.deletePaymentById(id)
  }

  paymentDeleted(){
    this.loading = false
    this.getData()
  }

  onVendorDetails(id:number) {
        this.rfqRef = this.modalService.create({
          nzTitle: 'Vendor Details',
          nzContent: CetVendorDetailsComponent,
          nzFooter: null,
          nzWidth:'90vw',
          nzStyle: {
              top: '40px',
          },
          nzData: {
            id: id
          }
        });
    
         
    
      }

  editPayment(data:any){
    this.cetPaymentModalRef =  this.modalService.create({
        nzTitle: 'Edit Payment',
        nzContent: CetPaymentModalComponent,
        nzFooter:null,
        nzWidth: '800px',
        nzStyle:{top:'50px'},
        nzData:{data:data},
        nzClosable: true,
        // nzOnOk: () => new Promise(resolve => setTimeout(resolve, 1000))
      });

      this.cetPaymentModalRef.afterClose.subscribe(result => {
        if (result === true) {
          this.getData();
        }
        });
  }

}
